import script from "./AppealLetterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AppealLetterSection.vue?vue&type=script&setup=true&lang=js"

import "./AppealLetterSection.vue?vue&type=style&index=0&id=e982dad2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e982dad2"]])

export default __exports__